import {EventEmitter} from 'eventemitter3'

export const healthCareEvent = new EventEmitter()

export const healthCareEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
    ROLE_CHANGE: 'ROLE_CHANGE',
    USER_MANAGEMENT_CHANGE: 'USER_MANAGEMENT_CHANGE',
}

export function getHealthCareEventKey(eventType, clientId) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case healthCareEventTypes.TABLE_CHANGE:
            return `HCP_TABLE_CHANGE`
        case healthCareEventTypes.ROLE_CHANGE:
            return `HCP_ROLE_CHANGE`
        case healthCareEventTypes.USER_MANAGEMENT_CHANGE:
            return `HCP_USER_MANAGEMENT_CHANGE`
        default:
            return ''
    }
}

//#region TABLE CHANGE
export function onHealthCareTableChangeListener(
    eventType = healthCareEventTypes.TABLE_CHANGE,
    data,
) {
    healthCareEvent.emit(getHealthCareEventKey(eventType), data)
}

export function onHealthCareTableChangeRemoveListener(
    eventType = healthCareEventTypes.TABLE_CHANGE,
) {
    healthCareEvent.removeListener(getHealthCareEventKey(eventType))
}

//#endregion

//#region ROLE CHANGE
export function onHealthCareRoleChangeListener(
    eventType = healthCareEventTypes.ROLE_CHANGE,
    data,
) {
    healthCareEvent.emit(getHealthCareEventKey(eventType), data)
}

export function onHealthCareRoleChangeRemoveListener(
    eventType = healthCareEventTypes.ROLE_CHANGE,
) {
    healthCareEvent.removeListener(getHealthCareEventKey(eventType))
}

//#endregion

//#region USER MANAGEMENT CHANGE
export function onHealthCareUserManagementChangeListener(
    eventType = healthCareEventTypes.USER_MANAGEMENT_CHANGE,
    data,
) {
    healthCareEvent.emit(getHealthCareEventKey(eventType), data)
}

export function onHealthCareUserManagementChangeRemoveListener(
    eventType = healthCareEventTypes.USER_MANAGEMENT_CHANGE,
) {
    healthCareEvent.removeListener(getHealthCareEventKey(eventType))
}
//#endregion
